var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrediction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1128.88 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#016492}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M846.81 782.37l0 124.87c0,61.6 82.08,67.26 82.08,-5.2l0 -119.67c0,-63.97 -82.08,-71.65 -82.08,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M726.98 879.73c-44.55,28.1 -6.21,95.21 41.34,68.96 44.53,-24.59 8.92,-100.68 -41.34,-68.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M587.29 880.44c-10.59,6.04 -11.33,-1.9 -18.44,19.96 -3.27,10.08 -2.87,21.47 2.75,32.08 10.44,19.67 35.63,27.74 56.37,16.24 42.71,-23.69 13.37,-99.14 -40.68,-68.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M587.35 740.3c-46.78,27.66 -5.08,94.11 41.32,68.55 41.2,-22.69 12.92,-100.62 -41.32,-68.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M727.14 739.79c-45.02,24.22 -6.95,97.03 41.58,68.73 40.13,-23.41 13.35,-98.27 -41.58,-68.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M104.9 8.36c-44.89,19.07 -32.57,77.52 -32.53,131.79l-0.21 904.42c0.22,76.57 11.7,84.42 87.95,84.02 127.31,-0.66 847.22,3.23 867.76,-5.71 39.29,-17.11 29.01,-83.47 28.99,-132.98l0.23 -510.33c-0.02,-75.99 -26.86,-86.08 -113.26,-85.37l0.08 -308.8c-0.03,-108.1 -54.33,-82.84 -257.08,-82.84 -54.44,0 -551.94,-6.95 -581.93,5.8zm328.26 1031.76c-104.69,-0.32 -194.18,-0.86 -217.82,-0.74 -58.35,0.3 -67.13,-5.7 -67.3,-64.29l0.16 -784.6c-0.03,-41.53 -9.46,-86.25 24.89,-100.84 22.95,-9.75 461.81,-4.44 503.47,-4.44 155.14,0 196.68,-19.32 196.71,63.38l-0.06 247.17c-21.93,0.52 -46.24,0.97 -73.2,0.97 -54.44,0 -304.12,-6.94 -334.11,5.8 -44.89,19.08 -32.57,77.52 -32.53,131.79l-0.21 505.8zm100.93 -556.3c-34.35,14.6 -24.92,59.32 -24.89,100.84l-0.16 390.43c0.17,58.59 8.95,64.6 67.3,64.29 64.31,-0.33 367.81,4.31 387.75,-4.38 30.07,-13.09 22.2,-63.86 22.18,-101.74l0.18 -390.49c-0.03,-82.71 -41.57,-63.39 -196.71,-63.39 -41.66,0 -232.7,-5.31 -255.65,4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M631.28 560.03l228.96 0c22.9,0 41.63,18.74 41.63,41.63l0 31.88c0,22.89 -18.73,41.62 -41.63,41.62l-228.96 0c-22.89,0 -41.62,-18.73 -41.62,-41.62l0 -31.88c0,-22.89 18.73,-41.63 41.62,-41.63z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrediction);
export default __webpack_public_path__ + "static/media/prediction.87abaaca5a0c87683dd6dc96b2a9fbc4.svg";
export { ForwardRef as ReactComponent };